var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 8C3.25 7.58579 3.58579 7.25 4 7.25H28C28.4142 7.25 28.75 7.58579 28.75 8C28.75 8.41421 28.4142 8.75 28 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8ZM3.25 16C3.25 15.5858 3.58579 15.25 4 15.25H28C28.4142 15.25 28.75 15.5858 28.75 16C28.75 16.4142 28.4142 16.75 28 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16ZM4 23.25C3.58579 23.25 3.25 23.5858 3.25 24C3.25 24.4142 3.58579 24.75 4 24.75H28C28.4142 24.75 28.75 24.4142 28.75 24C28.75 23.5858 28.4142 23.25 28 23.25H4Z",
    fill: "#172026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.1de9fba80f55a773a6c93b01b9f30d46.svg";
export { ForwardRef as ReactComponent };